<script>
import list from '../pages/Goods/list.vue'
import comments from '../pages/Orders/comments.vue'
import type from '../pages/Goods/type.vue'
import typeattribute from '../pages/Goods/typeattribute.vue'
import typepriceattr from '../pages/Goods/typepriceattr.vue'

import brand from '../pages/Goods/brand'
import category from '../pages/Goods/category'
import listcollection from '../pages/Goods/listcollection'

//广告
import ad from '../pages/Ad/index'
import editad from '../pages/Ad/editad'
import notices from '../pages/Notices/index'
import activityList from '../pages/Activity/list'
import lottery from '../pages/Lottery/index'
import groupbuy from '../pages/GroupBuy/index'

//系统管理
import emshop from '../pages/Config/emshop'
import expresscorp from '../pages/Config/expresscorp'

//订单
import orderList from '../pages/Orders/list'
import listsalerservice from '../pages/Orders/listsalerservice'
import memberList from '../pages/Members/list'
import funds from '../pages/Members/funds'
import listreservation from '../pages/Orders/listreservation' //预约管理

import aboutus from '../pages/Config/aboutus'
import payment from '../pages/Config/payment'

//文章管理
import articalcategory from '../pages/Artical/category'
import articallist from '../pages/Artical/list'
import articaledit from '../pages/Artical/edit'

//佣金抽成比例
import commissionConfig from '../pages/Commission/index'

import rbac_user_index from '../pages/System/rbac/user'
import rbac_role_index from '../pages/System/rbac/role'
import rbac_permission_index from '../pages/System/rbac/permission'

import recharge_card from '../pages/RechargeCard/list'

const routes = [
  { path: '/articals/list', name: 'artical_list', component: articallist },
  {
    path: '/articals/category',
    name: 'articalcategory',
    component: articalcategory,
  },
  { path: '/articals/edit', name: 'artical_edit', component: articaledit },

  { path: '/goods/list', name: 'goods_list', component: list },
  { path: '/orders/comments', name: 'goods_comments', component: comments },
  { path: '/goods/type', name: 'goods_type', component: type },
  {
    path: '/goods/typeattribute',
    name: 'goods_typeattribute',
    component: typeattribute,
  },
  {
    path: '/goods/typepriceattr',
    name: 'goods_typepriceattr',
    component: typepriceattr,
  },
  { path: '/goods/brand', name: 'goods_brand', component: brand },
  { path: '/goods/category', name: 'goods_category', component: category },
  {
    path: '/goods/listcollection',
    name: 'goods_listcollection',
    component: listcollection,
  },
  { path: '/marketing/ad', name: 'marketing_ad', component: ad },
  { path: '/marketing/notices', name: 'marketing_notices', component: notices },
  { path: '/marketing/editad', name: 'marketing_editad', component: editad },
  {
    path: '/marketing/activity',
    name: 'marketing_activity',
    component: activityList,
  },
  {
    path: '/marketing/lottery',
    name: 'marketing_lottery',
    component: lottery,
  },
  {
    path: '/marketing/groupbuy',
    name: 'marketing_groupbuy',
    component: groupbuy,
  },

  {
    path: '/config/expresscorp',
    name: 'config_expresscorp',
    component: expresscorp,
  },

  { path: '/orders/list', name: 'orderList', component: orderList },
  {
    path: '/orders/listreservation',
    name: 'listreservation',
    component: listreservation,
  },
  { path: '/members/list', name: 'membersList', component: memberList },
  { path: '/members/funds', name: 'funds', component: funds },

  {
    path: '/orders/listsalerservice',
    name: 'listsalerservice',
    component: listsalerservice,
  },
  {
    path: '/config/emshop',
    name: 'config_emshop',
    component: emshop,
  },
  {
    path: '/config/aboutus',
    name: 'config_aboutus',
    component: aboutus,
  },
  {
    path: '/config/payment',
    name: 'config_payment',
    component: payment,
  },
  {
    path: '/marketing/commission',
    name: 'commissionConfig',
    component: commissionConfig,
  },
  {
    path: '/system/rbac/user',
    name: 'system_rbac_user',
    component: rbac_user_index,
  },
  {
    path: '/system/rbac/role',
    name: 'system_rbac_role',
    component: rbac_role_index,
  },
  {
    path: '/system/rbac/permission',
    name: 'system_rbac_permission',
    component: rbac_permission_index,
  },
  {
    path: '/marketing/rechargecard',
    name: 'recharge_card',
    component: recharge_card,
  },
]

export default routes
</script>
